import './loader';

import './js/library-buttons';
import './js/add-to-localstorage-btn';

import './js/library-modal-open-close';
import './js/api';

import './js/button-up';

import './js/modal-team';

import './js/dark-mode';
